import Combine from '../../components/Combine/Combine'
import SignUpForm from './SignUpForm';


const SignUp = () => {
  return (
    <Combine>
      <h2 className='text-3xl  p-7'>Create Your Profile</h2>
      <SignUpForm/>
    </Combine>
  );
}

export default SignUp
